function resetRoadmap(self: any, totalColumns: number) {
	self.firstDisplayedCol = 0;
	self.totalColumns = totalColumns;
}

function resetDisplayPointer(self: any) {
	self.currentDisplayRow = 0;
	self.currentDisplayCol = 0;
	self.currentType = "";
}

function addDisplayTile(displayAry: JSX.Element[][], tile: JSX.Element, type: string, self: any) {
	// console.log("aDT", self.currentType, type);

	if (self.currentType !== type || self.currentDisplayRow >= 7) {
		self.currentDisplayRow = 0;
		self.currentDisplayCol++;
	} else {
		self.currentDisplayRow++;
	}
	
	displayAry[self.currentDisplayRow][self.currentDisplayCol] = tile;

	//nudge to the left on overflow
	if (self.currentDisplayCol > self.totalColumns) {
		// console.log("Overflow");
		self.firstDisplayedCol = self.currentDisplayCol - self.totalColumns;
	}
	
	self.currentType = type;
}

//Obsolete after Typescript conversion
// function bindShouldRoadmapUpdate(mainClass) {
// 	mainClass.shouldComponentUpdate = shouldRoadmapUpdate.bind(mainClass);
// }

// function shouldRoadmapUpdate(nextProps) {
// 	if (this.props.history.length !== nextProps.history.length ||
// 		this.props.historyBlink !== nextProps.historyBlink)
// 		return true;
// 	return false;
// }
	
export {
	resetRoadmap, resetDisplayPointer, addDisplayTile,
	
	// bindShouldRoadmapUpdate, shouldRoadmapUpdate
};
